import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useParams, useNavigate } from "react-router-dom";

import { Row, Col, Button, Container } from "react-bootstrap";
import { NoData } from "../../components/no-data/NoData";

import DefaultLayout from "../../components/layout/DefaultLayout";
import { fetchSingleStudentAction } from "./studentAction";

const StudentLanding = () => {
  const { _id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { singleStudent } = useSelector((state) => state.student);

  useEffect(() => {
    _id && dispatch(fetchSingleStudentAction(_id));
  }, [_id, dispatch]);

  // UI
  if (!singleStudent?._id) {
    return <NoData />;
  }

  return (
    <DefaultLayout>
      <Container className="page-lead">
        <hr />
        <Button
          variant="outline-secondary"
          onClick={() => navigate("/student")}
        >
          &lt; Back
        </Button>
        <h3>Student Info</h3>
        <hr />
        <Row>
          <Col>
            Full Name:{" "}
            <b>
              {singleStudent.fName} {singleStudent.lName}
            </b>
          </Col>
        </Row>
        <Row>
          <Col>
            Mobile: <b>{singleStudent.mobile}</b>
          </Col>
        </Row>
        <Row>
          <Col>
            Email: <b>{singleStudent.email}</b>
          </Col>
        </Row>
        <Row>
          <Col>
            SocialLink: <b>{singleStudent.socialLink}</b>
          </Col>
        </Row>
        <hr />
        <h5>More information to be added soon...............</h5>
      </Container>
    </DefaultLayout>
  );
};

export default StudentLanding;
